/**
 * Created by huzhongchun on 2018/4/26.
 */

//project_label
export const PROJECT_LABEL = 'ENGLISH';

//route base path
export const PRODUCT_ROUTE_BASE_PATH = '/english/page/index';
export const DEVELOPMENT_ROUTE_BASE_PATH = '';

//api host
export const API_ONLINE_HOST = window.location.protocol+'//api.taooo.cc';

//get token
export const GET_TOKEN_URL = '/english/page/get_token';
export const GET_TOKEN_REQUEST_BASEURL = window.location.origin;
export const GET_TOKEN_REQUEST_TYPE = 'english';

function getRouteBaseUrl () {
	if(process.env.NODE_ENV === 'development'){
		return DEVELOPMENT_ROUTE_BASE_PATH;
	}else{
		return PRODUCT_ROUTE_BASE_PATH;
	}
}


export let defaultShareInfo = {
	wechat_session: {
		title: '水滴阅读：每天10分钟，100天读完3本英文原著',
		text: '学英语就是⽤最小成本，改变人⽣处境的方法。',
		image: {
			url: 'http://static-thefair-bj.oss-cn-beijing.aliyuncs.com/english/drip.jpg'
		},
		link: window.location.protocol+'//h5.taooo.cc/english/page/index',
	},
	wechat_timeline: {
		title: '水滴阅读：每天10分钟，100天读完3本英文原著',
		text: '学英语就是⽤最小成本，改变人⽣处境的方法。',
		image: {
			url: 'http://static-thefair-bj.oss-cn-beijing.aliyuncs.com/english/drip.jpg'
		},
		link: window.location.protocol+'//h5.taooo.cc/english/page/index',
	}
};

export const tabBar = [
	{
		path: getRouteBaseUrl()+'/',
		root: true,
		text: '今日阅读',
		icon:'',
		activeIcon:''
	},
	{
		path: getRouteBaseUrl()+'/calendar',
		text: '阅读记录',
		icon:'',
		activeIcon:''
	},
	{
		path: getRouteBaseUrl()+'/user_center',
		text: '个人中心',
		icon:'',
		activeIcon:''
	},
];


export default {
	PRODUCT_ROUTE_BASE_PATH,
	DEVELOPMENT_ROUTE_BASE_PATH,
	API_ONLINE_HOST,
	GET_TOKEN_URL,
	defaultShareInfo,
	tabBar
};



// WEBPACK FOOTER //
// ./src/config/configEnglish.js